import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { DataResolverService } from './services/data-resolver.service';

import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NgxAgoraSdkNgModule } from 'ngx-agora-sdk-ng';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { MeetingPreviewComponent } from './pages/meeting-preview/meeting-preview.component';
import {
  RoundTranparentIconButtonComponent
} from './shared/components/round-tranparent-icon-button/round-tranparent-icon-button.component';
import { InputOutputSettingsComponent } from './shared/components/input-output-settings/input-output-settings.component';
import { SoundMeterComponent } from './shared/components/sound-meter/sound-meter.component';
import { CameraPreviewComponent } from './shared/components/camera-preview/camera-preview.component';
import { WelcomeComponent } from './pages/welcome/welcome.component';
import { MeetingPageComponent } from './pages/meeting-page/meeting-page.component';
import { AgoraVideoPlayerDirective } from './shared/directives/agora-video-player.directive';
import { MeetingControlsComponent } from './shared/components/meeting-controls/meeting-controls.component';
import { MeetingParticipantComponent } from './shared/components/meeting-participant/meeting-participant.component';
import { MeetingParticipantControlsComponent } from './shared/components/meeting-participant-controls/meeting-participant-controls.component';
import { SoundVisualizerComponent } from './shared/components/sound-visualizer/sound-visualizer.component';


const routes: Routes = [  
  {
    path: '',
    redirectTo: 'book-appointment',
    // redirectTo: 'bookappointment',
    pathMatch: 'full'
  },
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then( m => m.HomePageModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'pt-profile',
    loadChildren: () => import('./pt-profile/pt-profile.module').then( m => m.PtProfilePageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'video',
    loadChildren: () => import('./video/video.module').then( m => m.VideoPageModule)
  },
  {
    path: 'answervideocall',
    loadChildren: () => import('./answervideocall/answervideocall.module').then( m => m.AnswervideocallPageModule)
  },
  {
    path: 'book-appointment',
    loadChildren: () => import('./book-appointment/book-appointment.module').then( m => m.BookAppointmentPageModule)
    //canLoad: [AuthGuard]
  },
  {
    path: 'video-appointment-complaint',
    loadChildren: () => import('./video-appointment-complaint/video-appointment-complaint.module').then( m => m.VideoAppointmentComplaintPageModule)
  },
  {
    path: 'chatroom/:id',  
    resolve:{
      chatObj:DataResolverService
    },
    loadChildren: () => import('./chatroom/chatroom.module').then( m => m.ChatroomPageModule)
  },
  {
    path: 'followup-subscription/:id',
    resolve: {
      sbData: DataResolverService
    },
    loadChildren: () => import('./followup-subscription/followup-subscription.module').then( m => m.FollowupSubscriptionPageModule)
  },
  {
    path: 'signup',
    loadChildren: () => import('./signup/signup.module').then( m => m.SignupPageModule)
  },
  {
    path: 'preview-gallery-image',
    loadChildren: () => import('./preview-gallery-image/preview-gallery-image.module').then( m => m.PreviewGalleryImagePageModule)
  },
  {
    path: 'followup-finded-circle-doctors/:id',
    resolve: {
      cDocData: DataResolverService
    },
    loadChildren: () => import('./followup-finded-circle-doctors/followup-finded-circle-doctors.module').then( m => m.FollowupFindedCircleDoctorsPageModule)
  },
  {
    path: 'followup-circle-list',
    loadChildren: () => import('./followup-circle-list/followup-circle-list.module').then( m => m.FollowupCircleListPageModule)
  },
  {
    path: 'followup-subscribed-circle/:id',
    resolve: {
      curCircle: DataResolverService
    },
    loadChildren: () => import('./followup-subscribed-circle/followup-subscribed-circle.module').then( m => m.FollowupSubscribedCirclePageModule)
  },
  {
    path: 'followup-share-circle',
    loadChildren: () => import('./followup-share-circle/followup-share-circle.module').then( m => m.FollowupShareCirclePageModule)
  },
  {
    path: 'followup-manage-subscription',
    loadChildren: () => import('./followup-manage-subscription/followup-manage-subscription.module').then( m => m.FollowupManageSubscriptionPageModule)
  },
  {
    path: 'followup-handbook',
    loadChildren: () => import('./followup-handbook/followup-handbook.module').then( m => m.FollowupHandbookPageModule)
  },
  {
    path: 'followup-chat-complaint',
    loadChildren: () => import('./followup-chat-complaint/followup-chat-complaint.module').then( m => m.FollowupChatComplaintPageModule)
  },
  {
    path: 'followup-chatroom',
    resolve: {
      chatData: DataResolverService
    },
    loadChildren: () => import('./followup-chatroom/followup-chatroom.module').then( m => m.FollowupChatroomPageModule)
  },
  {
    path: 'followup-ctrm-preview-img',
    loadChildren: () => import('./followup-ctrm-preview-img/followup-ctrm-preview-img.module').then( m => m.FollowupCtrmPreviewImgPageModule)
  },  

  {
    path: 'view-image',
    loadChildren: () => import('./view-image/view-image.module').then( m => m.ViewImagePageModule)
  },
  {
    path: 'view-single-doc-appt',
    loadChildren: () => import('./view-single-doc-appt/view-single-doc-appt.module').then( m => m.ViewSingleDocApptPageModule)
  },
  {
    path: 'chat-room-file-upload-page',
    loadChildren: () => import('./chat-room-file-upload-page/chat-room-file-upload-page.module').then( m => m.ChatRoomFileUploadPagePageModule)
  },
  {
    path: 'view-booked-appointment',
    loadChildren: () => import('./view-booked-appointment/view-booked-appointment.module').then( m => m.ViewBookedAppointmentPageModule)
  },   
  {
    path: 'view-prescription/:id',
    resolve: {
      dxData: DataResolverService
    },
    loadChildren: () => import('./view-prescription/view-prescription.module').then( m => m.ViewPrescriptionPageModule)
  },
  {
    path: 'pending-bill',
    loadChildren: () => import('./pending-bill/pending-bill.module').then( m => m.PendingBillPageModule)
  },
  {
    path: 'cj',
    loadChildren: () => import('./cj/cj.module').then( m => m.CjPageModule)
  },
  {
    path: 'video-appt-waiting-room',
    loadChildren: () => import('./video-appt-waiting-room/video-appt-waiting-room.module').then( m => m.VideoApptWaitingRoomPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'waiting-room/:id',
    loadChildren: () => import('./waiting-room/waiting-room.module').then( m => m.WaitingRoomPageModule)
    //canLoad: [AuthGuard]
  },
  {
    path: 'rejoinmeeting/:id',
    resolve: {
      waitingRoom: DataResolverService
    },
    loadChildren: () => import('./rejoinmeeting/rejoinmeeting.module').then( m => m.RejoinmeetingPageModule)
  },
  {
    path: 'joinvideocall',
    loadChildren: () => import('./joinvideocall/joinvideocall.module').then( m => m.JoinvideocallPageModule)
  },
  { path: 'welcome', component: WelcomeComponent },
  { path: 'preview', component: MeetingPreviewComponent },
  { path: 'settings', component: InputOutputSettingsComponent },
  { path: 'meeting', component: MeetingPageComponent},  
  {
    path: 'consult/:id',
    loadChildren: () => import('./consult/consult.module').then( m => m.ConsultPageModule)
  },
  {
    path: 'singleconsult',
    loadChildren: () => import('./singleconsult/singleconsult.module').then( m => m.SingleconsultPageModule)
  },
  {
    path: 'book-appt-confirm',
    loadChildren: () => import('./book-appt-confirm/book-appt-confirm.module').then( m => m.BookApptConfirmPageModule)
  },
  {
    path: 'patientchatroom/:id',
    resolve:{
      chatData:DataResolverService
    },
    loadChildren: () => import('./patientchatroom/patientchatroom.module').then( m => m.PatientchatroomPageModule)
  },
  {
    path: 'appointment/:id',
    loadChildren: () => import('./appointment/appointment.module').then( m => m.AppointmentPageModule)
  },
  {
    path: 'book-video-appt-confirm',
    loadChildren: () => import('./book-video-appt-confirm/book-video-appt-confirm.module').then( m => m.BookVideoApptConfirmPageModule)
  },
  {
    path: 'select-appointment-type',
    loadChildren: () => import('./select-appointment-type/select-appointment-type.module').then( m => m.SelectAppointmentTypePageModule)
  },
  {
    path: 'video-appointment-complaint-update',
    loadChildren: () => import('./video-appointment-complaint-update/video-appointment-complaint-update.module').then( m => m.VideoAppointmentComplaintUpdatePageModule)
  },
  {
    path: 'single-doctor-slot',
    loadChildren: () => import('./single-doctor-slot/single-doctor-slot.module').then( m => m.SingleDoctorSlotPageModule)
  },
  {
    path: 'view-patient-prescription/:id',
    resolve: {
      ptdxData: DataResolverService
    },
    loadChildren: () => import('./view-patient-prescription/view-patient-prescription.module').then( m => m.ViewPatientPrescriptionPageModule)
  },
  {
    path: 'prescription-view-images',
    loadChildren: () => import('./prescription-view-images/prescription-view-images.module').then( m => m.PrescriptionViewImagesPageModule)
  },
  {
    path: 'zoomimage',
    loadChildren: () => import('./zoomimage/zoomimage.module').then( m => m.ZoomimagePageModule)
  },
  {
    path: 'join/:id',
    resolve: {
      videoObj: DataResolverService
    },
    loadChildren: () => import('./join/join.module').then( m => m.JoinPageModule)
  },
  {
    path: 'bookappointment',
    loadChildren: () => import('./bookappointment/bookappointment.module').then( m => m.BookappointmentPageModule)
  },  
  {
    path: 'otplogin',
    loadChildren: () => import('./otplogin/otplogin.module').then( m => m.OtploginPageModule)
  },
  {
    path: 'appointment-interface',
    loadChildren: () => import('./appointment-interface/appointment-interface.module').then( m => m.AppointmentInterfacePageModule)
  },
  {
    path: 'payment-success',
    loadChildren: () => import('./payment-success/payment-success.module').then( m => m.PaymentSuccessPageModule)
  },
  {
    path: 'doctor-appointment/:id',
    loadChildren: () => import('./doctor-appointment/doctor-appointment.module').then( m => m.DoctorAppointmentPageModule)
  },
  {
    path: 'video-call',
    loadChildren: () => import('./video-call/video-call.module').then( m => m.VideoCallPageModule)
  },
  {
    path: 'pre-screening-form',
    loadChildren: () => import('./pre-screening-form/pre-screening-form.module').then( m => m.PreScreeningFormPageModule)
  }














];

@NgModule({
  declarations: [
    MeetingPreviewComponent,
    RoundTranparentIconButtonComponent,
    InputOutputSettingsComponent,
    SoundMeterComponent,
    CameraPreviewComponent,
    WelcomeComponent,
    MeetingPageComponent,
    AgoraVideoPlayerDirective,
    MeetingControlsComponent,
    MeetingParticipantComponent,
    MeetingParticipantControlsComponent,
    SoundVisualizerComponent
  ],
  imports: [
    CommonModule,
    //RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
    ReactiveFormsModule,
    HttpClientModule,
    FontAwesomeModule,
    NgxAgoraSdkNgModule.forRoot({
      AppID: '9574c9a0ff9d41aa842ef6cc89e2904f',
      Video: { codec: 'h264', mode: 'rtc', role: 'host' }
    }),
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, useHash: true })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
